module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.tagType, _vm._b({
    tag: "div",
    staticClass: "InteractiveThumbnail"
  }, 'div', _vm.attributes, false), [(_vm.image) ? _c('thumbnail', {
    staticClass: "InteractiveThumbnail-image",
    attrs: {
      "image": _vm.image,
      "button": {
        icon: 'interactive',
        label: _vm.label
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40de8d2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InteractiveThumbnail.vue
// module id = 758
// module chunks = 1474